import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import ThunkMiddleware from 'redux-thunk';

import { rootReducer } from './sensor/sensorStore';

const persistConfig = {
  key: 'root3', // Updated key to force reset after enhancement
  storage,
  whitelist: ['persistence'],
  transforms: [],
  debug: process.env.NODE_ENV === 'development',
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const configurStore = () => {
  try {
    const store = configureStore({
      reducer: persistedReducer,
      middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
          serializableCheck: {
            ignoredActions: [
              'persist/PERSIST',
              'persist/REHYDRATE',
              'persist/REGISTER',
            ],
            ignoredPaths: ['register', 'rehydrate'],
          },
        }).concat(ThunkMiddleware),
      devTools: process.env.NODE_ENV !== 'production',
    });

    const persistor = persistStore(store);

    persistor.subscribe(() => {
      const state = persistor.getState();
      if (state.err) {
        console.error('Redux Persist Error:', state.err);
      }
    });

    return { store, persistor };
  } catch (error) {
    console.error('❌ Store configuration failed:', error);
    // Fallback: return a basic store without persistence
    const store = configureStore({
      reducer: rootReducer,
      middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(ThunkMiddleware),
    });

    return {
      store,
      persistor: {
        persist: () => {},
        purge: () => {},
        getState: () => ({ bootstrapped: true }),
      },
    };
  }
};
